export const TOGGLE_MENU = 'APP:TOGGLE_MENU';
export const TOGGLE_ACCOUNT_SWITCHER = 'APP:TOGGLE_ACCOUNT_SWITCHER';
export const ROOT_CLICK = 'APP:ROOT_CLICK';
